module.exports = __webpack_public_path__ + "img/MSMT.7bdad7a.svg";